module.exports = {
      id: "google-play-usage",
      viewBox: "0 0 180 53.333",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#google-play",
      toString: function () {
        return this.url;
      }
    }